"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const vue_router_1 = tslib_1.__importDefault(require("vue-router"));
// ONLY the entry point or global views should be imported in this way.
const Authentication_vue_1 = tslib_1.__importDefault(require("./views/Authentication.vue"));
const Registration_vue_1 = tslib_1.__importDefault(require("./views/Registration.vue"));
const ForgotUsername_vue_1 = tslib_1.__importDefault(require("./views/ForgotUsername.vue"));
const ForgotPassword_vue_1 = tslib_1.__importDefault(require("./views/ForgotPassword.vue"));
const LoginGrouping_vue_1 = tslib_1.__importDefault(require("./views/LoginGrouping.vue"));
vue_1.default.use(vue_router_1.default); // Call a use statement to tell Vue to use the router
function getRouter(config) {
    return new vue_router_1.default({
        mode: 'history',
        base: config.baseUrl || '/',
        routes: [
            {
                path: '/Authentication',
                component: Authentication_vue_1.default,
            },
            {
                path: '/Registration',
                component: Registration_vue_1.default,
            },
            {
                path: '/ForgotUsername',
                component: ForgotUsername_vue_1.default,
            },
            {
                path: '/ForgotPassword',
                component: ForgotPassword_vue_1.default,
            },
            {
                path: '/Authentication/LoginGrouping',
                component: LoginGrouping_vue_1.default,
            },
            {
                path: '*',
                redirect: '/Authentication',
            },
        ],
    });
}
exports.default = getRouter;
